<template>
  <Stack
    direction="col"
    align="center"
    justify="end"
    gap="xs"
    :breakpoints="{ direction: { sm: 'row' } }"
    class="w-full"
  >
    <Text tag="span" size="sm" class="!w-fit text-center sm:text-right" data-test-id="totalNumberOfItems">
      Showing {{ props.from }} to {{ props.to }} of
      <span :data-test-id="`number-of-${documentType}`"> {{ props.total }} </span> {{ props.documentType }}
    </Text>
    <Stack
      v-if="showItemsPerPageMenu"
      direction="col"
      gap="xs"
      class="w-full sm:w-[185px] relative"
      v-on-click-outside="closeDropdown"
    >
      <Stack
        align="center"
        justify="between"
        class="w-full sm:w-[185px] py-[9px] px-[10px] bg-white border-sm border-grey-default rounded-sm cursor-pointer"
        @click="toggleDropdown"
        data-test-id="itemsPerPage"
      >
        <Text tag="span">{{ selectedOption.label }}</Text>
        <span :class="['transition-transform duration-200', isExpanded && 'rotate-180']">
          <Icon name="chevron-down" :size="16" :color="getColor('mkm-blue-light')" />
        </span>
      </Stack>
      <Dropdown :active="isExpanded" class="w-full sm:w-[185px] absolute z-50 !shadow-all-sm mt-xl">
        <aside class="w-full bg-white py-2xs">
          <nav>
            <ul>
              <li
                v-for="(option, index) in props.options"
                :key="index"
                :class="[
                  'h-full w-full',
                  option.label === selectedOption.label
                    ? 'bg-mkm-blue-default text-white'
                    : 'bg-white hover:bg-grey-default',
                ]"
                @click="toggleDropdown"
              >
                <Stack tag="button" class="block w-full h-full px-sm py-[12px]" @click="updateSelectedOption(option)">
                  <Text tag="span" weight="semi" align="left">
                    {{ option.label }}
                  </Text>
                </Stack>
              </li>
            </ul>
          </nav>
        </aside>
      </Dropdown>
    </Stack>
  </Stack>
</template>

<script lang="ts" setup>
import { getColor } from "mkm-avengers";
import { ItemsPerPageOption, ItemsPerPageSelectorProps } from "./itemsPerPageSelectorTypes";
import { vOnClickOutside } from "@vueuse/components";

const props = withDefaults(defineProps<ItemsPerPageSelectorProps>(), {
  showItemsPerPageMenu: true,
  options: () => [
    { label: "10 per page", value: 10 },
    { label: "25 per page", value: 25 },
    { label: "50 per page", value: 50 },
  ],
});

const emit = defineEmits<{
  (event: "update:items", value: number): void;
}>();

const selectedOption = ref<ItemsPerPageOption>({ label: "Items per page", value: null });
const isExpanded = ref(false);

const updateSelectedOption = (value: ItemsPerPageOption) => {
  selectedOption.value = value;
  emit("update:items", value.value as number);
};

const toggleDropdown = () => {
  isExpanded.value = !isExpanded.value;
};

const closeDropdown = () => {
  isExpanded.value = false;
};
</script>
